import { render, staticRenderFns } from "./ClaimQuickInfo.vue?vue&type=template&id=2e1fc59c&"
import script from "./ClaimQuickInfo.vue?vue&type=script&lang=js&"
export * from "./ClaimQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClaimQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimQuickInfo.vue"
export default component.exports